import App from './App.svelte';

const app = new App({
    target: document.body,
    props: {
        pages: [
            'cover',
            'intro',
            'intro2',
            'day1',
            'day2',
            'day3',
            'day4',
            'day5',
            'day6',
            'day7',
            'day8',
            'day9',
            'day10',
            'day11',
            'day12',
            'validarien',
            'end']
    }
});

export default app;